/**
 * Parallax Images Component
 * Adds subtle parallax effect to images on scroll
 */
export default class ParallaxImages {
  constructor() {
    this.$parallaxElements = $('[data-parallax]')
    this.scrollPosition = 0
    this.ticking = false
  }

  init() {
    if (this.$parallaxElements.length === 0) return

    // Initial position setup
    this.updateParallax()

    // Update on scroll with requestAnimationFrame for better performance
    $(window).on('scroll', () => {
      this.scrollPosition = $(window).scrollTop()
      this.requestTick()
    })

    // Update on resize
    $(window).on('resize', () => {
      this.updateParallax()
    })
  }

  requestTick() {
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.updateParallax()
        this.ticking = false
      })
      this.ticking = true
    }
  }

  updateParallax() {
    const windowWidth = $(window).width()
    const windowHeight = $(window).height()
    const scrollTop = this.scrollPosition || $(window).scrollTop()

    // Only apply parallax on viewports wider than 767px
    if (windowWidth <= 767) {
      this.$parallaxElements.css({
        transform: 'translate3d(0, 0, 0)',
      })
      return
    }

    this.$parallaxElements.each((index, element) => {
      const $element = $(element)
      const elementTop = $element.offset().top
      const elementHeight = $element.outerHeight()
      const elementBottom = elementTop + elementHeight

      // Check if element is in viewport
      if (elementBottom > scrollTop && elementTop < scrollTop + windowHeight) {
        // Get parallax speed from data attribute (default: 0.3)
        const speed = parseFloat($element.attr('data-parallax-speed')) || 0

        // Calculate scroll progress through viewport
        // 0 = element just entering viewport from bottom
        // 1 = element just leaving viewport from top
        const scrollProgress = (scrollTop + windowHeight - elementTop) / (windowHeight + elementHeight)

        // Clamp progress between 0 and 1
        const clampedProgress = Math.max(0, Math.min(1, scrollProgress))

        // Calculate translate value: starts at 0, increases as element scrolls up
        const translateY = clampedProgress * 100 * speed

        // Apply transform
        $element.css({
          transform: `translate3d(0, -${translateY}px, 0)`,
        })
      }
    })
  }
}

new ParallaxImages().init()
